/**
 * Return true if start time is less than end time
 */
const isValidTimeSelection = (startTime: number, endTime: number): boolean => startTime < endTime;
export default isValidTimeSelection;
